import axios from 'axios';


export const extBaseUrl = process.env.REACT_APP_CONTROL_ROOM_URL


const instance = axios.create({
  baseURL: extBaseUrl
});

instance.interceptors.request.use((request) => {

  let user = JSON.parse(localStorage.getItem('user'))

  request.headers = {
    'Accept': "application/json, text/plain, */*",
    'Authorization': `Bearer ${user?.access_token}`,
   
    // 'api-key': process.env.REACT_APP_API_KEY, 
    'Content-Type': 'application/x-www-form-urlencoded',
  }
  return request
});

instance.interceptors.response.use((response) => {
  if (response) {
    return response
  }
}, (error) =>
  Promise.reject(
    error
  )
);

export default instance;